import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ReportingTaxYearSettingModel } from '../../Models/Models/Customer/Regulatory/ReportingTaxYearSettingModel';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class ReportingTaxYearSettingClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<ReportingTaxYearSettingModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ReportingTaxYearSetting/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<ReportingTaxYearSettingModel>, any>(url, data);
  }
  public put(customerId: number, model: Array<ReportingTaxYearSettingModel>): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/ReportingTaxYearSetting/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, model: model }

    return AjaxWrapper.put<ValidationStatus, any>(url, data);
  }
}

